import URL from './url'
import http from '@/utils/httpUtils'

export default {
  // 每日食谱详情 get
  recipesDialyDetail(_postData) {
    return http.get(URL.API_RECIPES_DAILY_DETAIL, _postData)
  },
  // 食谱发布状态列表 get
  recipesDailyStates(_postData) {
    return http.get(URL.API_RECIPES_DAILY_STATUS, _postData)
  },
  // 删除食谱 post
  recipesDelete(_postData) {
    return http.post(URL.API_RECIPES_DELETE, _postData)
  },
  // 餐点类型列表 get
  recipesMealTypes(_postData) {
    return http.get(URL.API_RECIPES_MEAL_TYPES, _postData)
  },
  // 保存食谱 post
  recipesSave(_postData) {
    return http.post(URL.API_RECIPES_SAVE, _postData)
  },
  // 批量添加菜品 post
  recipesCuisineBatchAdd(_postData) {
    return http.post(URL.API_RECIPES_CUISINE_BATCH_ADD, _postData)
  },
  // 删除菜品 post
  recipesCuisineDelete(_postData) {
    return http.post(URL.API_RECIPES_CUISINE_DELETE, _postData)
  },
  // 菜品详情 get
  recipesCuisineGet(_postData) {
    return http.get(URL.API_RECIPES_CUISINE_GET, _postData)
  },
  // 菜品列表 get
  recipesCuisinePage(_postData) {
    return http.get(URL.API_RECIPES_CUISINE_PAGE, _postData)
  },
  // 菜品搜索 get
  recipesCuisineSearch(_postData) {
    return http.get(URL.API_RECIPES_CUISINE_SEARCH, _postData)
  },
  // 菜品分类列表 get
  recipesCuisineTypes(_postData) {
    return http.get(URL.API_RECIPES_CUISINE_TYPES, _postData)
  },
  // 单个编辑菜品 post
  recipesCuisineUpdate(_postData) {
    return http.post(URL.API_RECIPES_CUISINE_UPDATE, _postData)
  },
  // 获取通知设置 get
  recipesConfigGet(_postData) {
    return http.get(URL.API_RECIPES_CONFIG_GET, _postData)
  },
  // 保存设置 post
  recipesConfigSave(_postData) {
    return http.post(URL.API_RECIPES_CONFIG_SAVE, _postData)
  }
}
